const Chainup = () => {
  return (
    <div className="w-full h-screen bg-cover bg-center bg-no-repeat bg-[url('https://s3.ap-northeast-2.amazonaws.com/coala.co.kr/files/chainup.png')]"></div>
  );
};

export default Chainup;
